.filter-bar-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
}

@media (max-width: 970px) {
  .filter-bar-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }
}
